// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile view (e.g., devices narrower than 600px) */
@media (max-width: 600px) {
  .shop-shell-main {
    padding: 0.5rem;  /* Smaller padding for mobile */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/ShopShell.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE;IACE,eAAe,GAAG,+BAA+B;EACnD;AACF","sourcesContent":["/* Mobile view (e.g., devices narrower than 600px) */\n@media (max-width: 600px) {\n  .shop-shell-main {\n    padding: 0.5rem;  /* Smaller padding for mobile */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
